import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ImageZoom = ({url}) => {
  return (
    <Zoom>
      <img
        src={url}
        alt="Example"
        // width="500"
        style={{ cursor: "zoom-in" }}
      className="max-w-full max-h-[60vh]"
      />
    </Zoom>
  );
};

export default ImageZoom;
